import axios from "axios";
import { Tokens } from "@okta/okta-auth-js";
import log from "../utils/logger";

import { User } from "@/types/user";
import { AuthData } from "@/types/auth";

import { API_BASE_URL } from "@/constants";

export const api = axios.create({
  baseURL: API_BASE_URL,
});

export const loginUser = async (username: string, password: string): Promise<AuthData> => {
  try {
    const response = await api.post("/auth/login", {
      username,
      password,
    });

    api.defaults.headers.common["Authorization"] = `Bearer ${response.data.accessToken}`;

    return response.data;
  } catch (error) {
    log.error("Login error", undefined, error);
    throw error;
  }
};

export const loginOktaUser = async (
  name: string,
  email: string,
  username: string,
  customerId: string,
  tokens: Tokens
): Promise<AuthData> => {
  try {
    const response = await api.post(
      "/auth/okta-login",
      { name, email, username, customerId },
      { headers: { Authorization: `Bearer ${tokens.accessToken.accessToken}` } }
    );
    api.defaults.headers.common["Authorization"] = `Bearer ${response.data.accessToken}`;
    return response.data;
  } catch (error) {
    log.error("Okta login error", undefined, error);
    throw error;
  }
};

export const refreshToken = async (refreshToken: string): Promise<any> => {
  try {
    const response = await api.post("/auth/refresh", {
      refreshToken,
    });
    return response.data;
  } catch (error) {
    log.error("Refresh token error", undefined, error);
    throw error;
  }
};

export const updatePassword = async (currentPassword: string, newPassword: string): Promise<User> => {
  try {
    const response = await api.post<{ body: User }>("/auth/update-password", { currentPassword, newPassword });
    return response.data.body;
  } catch (error) {
    log.error("Update password error", undefined, error);
    throw error;
  }
};

export const forgotPassword = async (email: string): Promise<User> => {
  try {
    const response = await api.post<{ body: User }>("/auth/forgot-password", { email });
    return response.data.body;
  } catch (error) {
    log.error("Forgot password error", undefined, error);
    throw error;
  }
};

export const logoutUser = async (): Promise<void> => {
  try {
    await api.post("/auth/logout");
  } catch (error) {
    log.error("Logout error", undefined, error);
    // Don't throw - silently fail
  }
};
